/* eslint-disable @typescript-eslint/no-explicit-any */
import { PrevAxios } from '../prev-front-mf-api'
import { getToken } from '../adapter/utils'
import { API_HOST } from '../constants'
interface DownloadPdfProps {
  filename: string
  html: string
  params?: any
}

/**
 * Faz o download de um PDF a partir de um HTML fornecido.
 *
 * @param {DownloadPdfProps} props - As propriedades necessárias para o download do PDF.
 * @param {string} props.filename - O nome do arquivo PDF a ser gerado.
 * @param {string} props.html - O conteúdo HTML que será convertido em PDF.
 * @param {object} [props.params] - Parâmetros adicionais opcionais.
 * @returns {Promise<any>} - Uma promessa que resolve com a resposta da requisição.
 */
export const downloadPdf = async (props: DownloadPdfProps, isCalculo?: boolean): Promise<any> => {
  const url = isCalculo ? `${API_HOST}/download-converter/pdf/calculo` : `${API_HOST}/download-converter/pdf`
  const localToken = getToken()
  const payload: DownloadPdfProps = {
    filename: props.filename,
    html: props.html,
  }
  if (props.params) payload.params = props.params
  const response = await PrevAxios({
    method: 'post',
    url: url,
    data: payload,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localToken ?? ''}`,
    },
  })
  return response
}
